import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _createSuper from "@babel/runtime/helpers/createSuper";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { createButton } from '@flowio/react-button';
import { Menu } from '@flowio/react-menu';
import { Popover } from '@flowio/react-popover';
import React from 'react';
var defaultProps = {
  closeOnClickAway: true,
  closeOnEscape: true,
  closeOnInvisible: false,
  closeOnSelection: true,
  constraint: 'flipfit flipfit',
  inline: false,
  items: [],
  offset: '0px 2px',
  openOnClick: true,
  openOnSpace: true,
  position: 'bottom left'
};

function getInitialState(props) {
  var _props$defaultOpen = props.defaultOpen,
      defaultOpen = _props$defaultOpen === void 0 ? false : _props$defaultOpen,
      open = props.open;
  return {
    open: open != null ? open : defaultOpen
  };
}

function getDerivedStateFromProps(props, state) {
  return {
    open: props.open != null ? props.open : state.open
  };
}

var Dropdown = /*#__PURE__*/function (_React$Component) {
  _inherits(Dropdown, _React$Component);

  var _super = _createSuper(Dropdown);

  function Dropdown(props) {
    var _this;

    _classCallCheck(this, Dropdown);

    _this = _super.call(this, props);
    _this.handleItemSelection = _this.handleItemSelection.bind(_assertThisInitialized(_this));
    _this.handlePopoverClose = _this.handlePopoverClose.bind(_assertThisInitialized(_this));
    _this.handlePopoverOpen = _this.handlePopoverOpen.bind(_assertThisInitialized(_this));
    _this.state = getInitialState(props);
    return _this;
  }

  _createClass(Dropdown, [{
    key: "handlePopoverClose",
    value: function handlePopoverClose() {
      this.close();
    }
  }, {
    key: "handlePopoverOpen",
    value: function handlePopoverOpen() {
      this.open();
    }
  }, {
    key: "handleItemSelection",
    value: function handleItemSelection(index, value) {
      var onItemSelection = this.props.onItemSelection;

      if (typeof onItemSelection === 'function') {
        onItemSelection(index, value);
      }

      this.closeOnSelection();
    }
  }, {
    key: "isOpenControlled",
    value: function isOpenControlled() {
      var open = this.props.open;
      return open != null;
    }
  }, {
    key: "open",
    value: function open() {
      var onOpen = this.props.onOpen;
      var open = this.state.open;

      if (!open) {
        if (!this.isOpenControlled()) {
          this.setState({
            open: true
          });
        }

        if (typeof onOpen === 'function') {
          onOpen();
        }
      }
    }
  }, {
    key: "close",
    value: function close() {
      var onClose = this.props.onClose;
      var open = this.state.open;

      if (open) {
        if (!this.isOpenControlled()) {
          this.setState({
            open: false
          });
        }

        if (typeof onClose === 'function') {
          onClose();
        }
      }
    }
  }, {
    key: "closeOnSelection",
    value: function closeOnSelection() {
      var closeOnSelection = this.props.closeOnSelection;

      if (closeOnSelection) {
        this.close();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var open = this.state.open;
      var _this$props = this.props,
          children = _this$props.children,
          closeOnClickAway = _this$props.closeOnClickAway,
          closeOnEscape = _this$props.closeOnEscape,
          closeOnInvisible = _this$props.closeOnInvisible,
          constraint = _this$props.constraint,
          inline = _this$props.inline,
          items = _this$props.items,
          offset = _this$props.offset,
          openOnClick = _this$props.openOnClick,
          openOnSpace = _this$props.openOnSpace,
          position = _this$props.position,
          trigger = _this$props.trigger,
          onClick = _this$props.onClick;
      /* eslint-disable @typescript-eslint/unbound-method */

      return /*#__PURE__*/React.createElement(Popover, {
        closeOnClickAway: closeOnClickAway,
        closeOnEscape: closeOnEscape,
        closeOnInvisible: closeOnInvisible,
        closeOnResize: false,
        closeOnScroll: false,
        constraint: constraint,
        inline: inline,
        offset: offset,
        onClose: this.handlePopoverClose,
        onOpen: this.handlePopoverOpen,
        onClick: onClick,
        open: open,
        openOnClick: openOnClick,
        openOnFocus: false,
        openOnHover: false,
        openOnSpace: openOnSpace,
        position: position,
        trigger: createButton(trigger)
      }, children != null ? children : /*#__PURE__*/React.createElement(Menu, {
        items: items,
        onItemSelection: this.handleItemSelection
      }));
      /* eslint-enable */
    }
  }]);

  return Dropdown;
}(React.Component);

_defineProperty(Dropdown, "displayName", 'Dropdown');

_defineProperty(Dropdown, "defaultProps", defaultProps);

_defineProperty(Dropdown, "getDerivedStateFromProps", getDerivedStateFromProps);

export default Dropdown;